var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.generalTableData)?_c('JindiaoTable',{attrs:{"data":_vm.generalTableData,"mode":"more"}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }